// extracted by mini-css-extract-plugin
export default {"cls1":"YsZaRUY3NXb0RDrPcc42","cls2":"OEg04qEh2m5QI_ND3UTE YsZaRUY3NXb0RDrPcc42"};